/**
 * Build a cacheable image URL for a `user_generations` entry.
 *
 * The Tripo wand refine REPLACES the GridFS bytes in-place at the same
 * gen id, which means the URL `/api/user-images/<uid>/<gid>.png` is
 * identical before and after a refine — so every browser between the
 * user and our server happily serves the stale render from cache.
 *
 * We tag every refined gen with a `refined_at` ISO timestamp; appending
 * it as `?v=…` busts every layer of cache (browser, CDN, service-worker)
 * the moment a refine completes, while still letting unrefined renders
 * stay cached forever (they have no `refined_at`).
 *
 * Use this everywhere we render a generation image — never inline.
 */
export const renderImageUrl = (backendUrl, gen) => {
  if (!gen?.image_url) return "";
  const bust = gen.refined_at ? `?v=${encodeURIComponent(gen.refined_at)}` : "";
  return `${backendUrl}${gen.image_url}${bust}`;
};
